import React, { useEffect } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import PublicRoute from "./components/routes/PublicRoute";

import config from "./config";
import Dashboard from "./pages/Dashboard";
import Maindashboard from "./pages/Maindashboard";
import Users from "./pages/Users";

import Login from "./pages/Login";
import axios from "./config/axios";
import AdminRoute from "./components/routes/AdminRoute";
import RpaRoute from "./components/routes/RpaRoute";

import ComputervisionRoute from "./components/routes/ComputervisionRoute";

import CreditriskRoute from "./components/routes/CreditriskRoute";

import VttRoute from "./components/routes/VttRoute";
import MarketinganalyticsRoute from "./components/routes/MarketinganalyticsRoute";
import B2BMarketinganalyticsRoute from "./components/routes/B2BMarketinganalyticsRoute";
import DashboardRoute from "./components/routes/DashboardRoute";
import CustomersegmentationRoute from "./components/routes/CustomersegmentationRoute";
import OcrRoute from "./components/routes/OcrRoute";
import PredictiveRoute from "./components/routes/PredictiveRoute";
import { getCurrentUser } from "./services/auth";

import GuestUserRoute from "./components/routes/GuestUserRoute";
import CaresolRoute from './components/routes/CaresolRoute'
import Creditriskmodel from "./pages/Creditriskmodel";
import Rpa from "./pages/Rpa";
import Marketinganalytics from "./pages/Marketinganalytics";
import B2BMarketinganalytics from "./pages/B2BMarketinganalytics";
import Videototext from "./pages/Videototext";
import Ocr from "./pages/Ocr";
import Customersegmentation from "./pages/Customersegmentation";
import Computervision from "./pages/Computervision";
import Predictiveanalytics from "./pages/Predictiveanalytics";
import Caresol from './pages/Caresol';
import PswRoute from './components/routes/PswRoute';
import ElmRoute from './components/routes/ElmRoute';
import DesignDashboardRoute from './components/routes/DesignDashboardRoute';
import LulusarRoute from './components/routes/LulusarRoute';
import Lulusar from './pages/Lulusar/Lulusar';
import OcrCaseStudyRoute from './components/routes/OcrCaseStudy'
import GenAiRoute from './components/routes/GenAi'
import PSW from './pages/PSW/PSW';
import Elm from './pages/ELM/Elm';
import DesignDashboard  from './pages/DesignDashboard/DesignDashboard';
import GenAi from "./pages/GenAi/GenAi";
import OcrCaseStudy from './pages/OcrCaseStudy/Ocr';
import FTRoute from './components/routes/FTRoute';
import LevisRoute from './components/routes/LevisRoute';
import Levis from './pages/Levis/Levis'
import FT from './pages/FleetTracking/FleetTracking'
import Hubspot from "./pages/Hubspot/Hubspot";
import HubspotRoute from "./components/routes/HubspotRoute";
import LinkedIn from './pages/LinkedIn/LinkedIn';
import LinkedInRoute from './components/routes/LinkedInRoute';
import MarketingAnalyticsCs from './pages/MarketingAnalyticsCs/MarketingAnalyticsCs'
import MarketingAnalyticsCsRoute from './components/routes/MarketingAnalyticsCsRoute'
import PaidOrganicRoute from './components/routes/PaidOrganicRoute'
import PaidOrganicAnalytics from "./pages/OrganicPaidAnalytics/OrganicPaidAnalytics"
import DpStackOverFlowRoute from './components/routes/DpStackOverFlowRoute'
import DpStackOverFlow from './pages/DpStackOverflow/DpStackOverFlow'
import ChurnRoute from './components/routes/ChurnRoute'
import ChurnCaseStudy from "./pages/ChurnCaseStudy/ChurnCaseStudy"
import HealthCareRoute from './components/routes/HealthCareRoute'
import HealthCare from './pages/HealthCare/HealthCare'
import CompetitiveLandscapeRoute from './components/routes/CompetitiveLandscapeRoute'
import CompetitiveLandscapeMonitoringPlatform from './pages/CompetitiveLandscapeMonitoringPlatform/CompetitiveLandscapeMonitoringPlatform'
import AiPoweredMedicalResearchIntelligencePlatform from './pages/AI-Powered Medical Research Intelligence Platform/AI-Powered Medical Research Intelligence Platform'
import SpartanRoute from './components/routes/SpartanRoute'
import Spartan from './pages/Spartan/Spartan'
import DatatramRoute from './components/routes/DatatramRoute'
import Datatram from './pages/Datatram/Datatram'
import OutformRoute from './components/routes/OutformRoute'
import Outform from './pages/Outform/Outform'
import DFSRoute from './components/routes/DFSRoute'
import DFS from './pages/DFS/DFS'
import ADSRoute from './components/routes/ADSRoute'
import ADS from './pages/ADS/ADS'
export default function AppRouter() {
  const token = localStorage.getItem(config.keys.token);
  const user = localStorage.getItem(config.keys.user);

  useEffect(() => {
    window.addEventListener("load", () => {
      axios.setHeaders(token);
      setTimeout(() => {
        if (user) {
          getCurrentUser()
            .then((res) => {
              localStorage.setItem(
                config.keys.user,
                JSON.stringify(res.data.user)
              );
            })
            .catch((ex) => {
              if (ex.response && ex.response.status === 401) {
                // session.setSessionExpired(true);
              }
            });
        }
      }, 2000);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <PublicRoute
            path={config.routes.login}
            component={Login}
            // component={LoginGuestUser}
            restricted={true}
            exact
          />
          <GuestUserRoute
            path={config.routes.maindashboard}
            component={Maindashboard}
          />
          <CaresolRoute
            path={config.routes.maindashboards}
            component={Caresol}
          />

          <PswRoute
           path={config.routes.PSW}
           component={PSW}
          />
          <ElmRoute
          path={config.routes.Elm}
          component={Elm}
         />
         <DesignDashboardRoute
         path={config.routes.DesignDashboard}
         component={DesignDashboard}
         />
         <HealthCareRoute
         path={config.routes.HealthCare}
         component={HealthCare}
         />
         <CompetitiveLandscapeRoute
          path={config.routes.CompetitiveLandscape}
          component={CompetitiveLandscapeMonitoringPlatform}
         />
         <HealthCareRoute
         path={config.routes.MedicalResearchIntelligencePlatform}
         component={AiPoweredMedicalResearchIntelligencePlatform}
         />
         <SpartanRoute
         path={config.routes.Spartan}
         component={Spartan}
         />
         <DatatramRoute
         path={config.routes.Datatram}
         component={Datatram}
         />
          <OutformRoute
          path={config.routes.Outform}
          component={Outform}
          />
         <DFSRoute
          path={config.routes.DFS}
          component={DFS}
          />
         <ADSRoute
          path={config.routes.ADS}
          component={ADS}
          />
 <LinkedInRoute
          path={config.routes.LinkedInRoute}
          component={LinkedIn}
         />
          <PaidOrganicRoute
          path={config.routes.PaidOrganicMedia}
          component={PaidOrganicAnalytics}
         />
          <HubspotRoute
          path={config.routes.Hubspot}
          component={Hubspot}
         />
        
          <LevisRoute
          path={config.routes.Levis}
          component={Levis}
         />

<ChurnRoute
          path={config.routes.Churn}
          component={ChurnCaseStudy}
         />


          <FTRoute
          path={config.routes.FTRoute}
          component={FT}
         />
         <MarketingAnalyticsCsRoute
           path={config.routes.MarketingAnalytics}
           component={MarketingAnalyticsCs}
         />
          <LulusarRoute
          path={config.routes.Lulusar}
          component={Lulusar}
         />
          <OcrCaseStudyRoute
          path={config.routes.OcrCaseStudy}
          component={OcrCaseStudy}
         />
          <GenAiRoute
          path={config.routes.GenAi}
          component={GenAi}
         />
           <DpStackOverFlowRoute
          path={config.routes.DataPilotStackOverFlow}
          component={DpStackOverFlow}
         />
          <MarketinganalyticsRoute
            path={config.routes.marketinganalytics}
            component={Marketinganalytics}
          />
          <B2BMarketinganalyticsRoute
            path={config.routes.b2bmarketinganalytics}
            component={B2BMarketinganalytics}
          />
          <DashboardRoute
            path={config.routes.dashboard}
            component={Dashboard}
          />

          {/* <GuestUserRoute
            path={config.routes.dashboard}
            component={Dashboard}
          /> */}
          <AdminRoute path={config.routes.users} component={Users} />
          <CustomersegmentationRoute
            path={config.routes.customersegmentation}
            component={Customersegmentation}
          />
          <RpaRoute path={config.routes.rpa} component={Rpa} />
          <VttRoute path={config.routes.videototext} component={Videototext} />
          <OcrRoute path={config.routes.ocr} component={Ocr} />
          <ComputervisionRoute
            path={config.routes.computervision}
            component={Computervision}
          />

<CreditriskRoute
            path={config.routes.creditriskmodel}
            component={Creditriskmodel}
          />

          <PredictiveRoute
            path={config.routes.predictiveanalytics}
            component={Predictiveanalytics}
          />
        </Switch>
      </BrowserRouter>
    </div>
  );
}
